export default __webpack_public_path__ + "static/media/Consentimiento.cf1dbbc2.pdf";